import React from "react";

export default function ProgressBar({ value, total }) {
  const pct = total > 0 ? Math.min(100, (value / total) * 100) : 0;
  return (
    <div
      className="w-full max-w-3xl mx-auto"
      data-testid="progress-bar-wrap"
    >
      <div className="flex items-center justify-between mb-2">
        <span className="label-eyebrow" data-testid="stat-learned">
          {value} / {total} öğrenildi
        </span>
        <span className="label-eyebrow text-[#a3aba6]">
          %{Math.round(pct)}
        </span>
      </div>
      <div
        className="relative h-[3px] w-full bg-[#e8eae3] rounded-full overflow-hidden"
        data-testid="progress-bar"
      >
        <div
          className="absolute inset-y-0 left-0 bg-[#4a6741] rounded-full transition-[width] duration-500 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
